import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const IosDeepLinkRedirect = () => {
  const { roomId } = useParams();

  useEffect(() => {
    const appUrl = `wannaeat://app/ChatDetails/${roomId}`;
    const fallbackUrl = 'https://apps.apple.com/us/app/wannaeat/id1661904255';

    window.location.href = appUrl;

    const timer = setTimeout(() => {
      window.location.href = fallbackUrl;
    }, 2000);

    return () => clearTimeout(timer);
  }, [roomId]);

  return <p style={{ textAlign: 'center', marginTop: 40 }}>Opening WannaEat app...</p>;
};

export default IosDeepLinkRedirect;